module.exports = __webpack_public_path__ + "img/logo_instagram.ce9f0275.png";